import { filter } from 'lodash';
import { withStyles, createStyles, makeStyles } from '@material-ui/styles';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import {
  Card,
  Table,
  TableRow,
  TableBody,
  TableCell,
  Container,
  Typography,
  TableContainer,
  TablePagination,
  IconButton
} from '@material-ui/core';
import VisibilityIcon from '@material-ui/icons/Visibility';
import PageviewIcon from '@material-ui/icons/Pageview';
import axios from 'axios';
import Scrollbar from '../Scrollbar';
import SearchNotFound from '../SearchNotFound';
import { ClientListHead, ClientListToolbar } from '../_dashboard/clients';
import { useSettingContext } from '../../context/setting_context';
import { useClientContext } from '../../context/client_context';
import { useClaimsContext } from '../../context/claims_context';
import { baseUrl } from '../../utils/constants';

const useStyles = makeStyles(() => ({
  markVerified: {
    backgroundColor: '#2979ff ',
    color: 'white'
  },
  markUnverified: {
    backgroundColor: '#ff5252',
    color: 'black'
  },
  tableFooter: {
    backgroundColor: 'black',
    color: 'white',
    size: 'small'
  }
}));

const StyledTableRow = withStyles((theme) =>
  createStyles({
    root: {
      '&:nth-of-type(odd)': {
        backgroundColor: theme.palette.action.hover
      }
    }
  })
)(TableRow);

const TABLE_HEAD = [
  { id: 'memNo', label: 'Tariff #', alignRight: false },
  { id: 'name', label: 'Description', alignRight: false }
];

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function applySortFilter(array, comparator, query) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  if (query) {
    return filter(
      array,
      (_user) => _user.tariffDescription.toLowerCase().indexOf(query.toLowerCase()) !== -1
    );
  }
  return stabilizedThis.map((el) => el[0]);
}

export default function Client() {
  const { tariffList } = useSettingContext();
  const { refreshClientValues, setDependant, setDependantList, setParentRefId } =
    useClientContext();
  const { getLimitUsage, getLimitTotalUsage, setClaimDetailsList } = useClaimsContext();
  const [page, setPage] = useState(0);
  const [order, setOrder] = useState('asc');
  const [selected, setSelected] = useState([]);
  const [orderBy, setOrderBy] = useState('surname');
  const [filterName, setFilterName] = useState('');
  const [rowsPerPage, setRowsPerPage] = useState(8);
  const navigate = useNavigate();
  const classes = useStyles();
  const dept = sessionStorage.getItem('dept');

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelecteds = tariffList.map((n) => n.surname);
      setSelected(newSelecteds);
      return;
    }
    setSelected([]);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleFilterByName = (event) => {
    setFilterName(event.target.value);
  };

  const handleClientView = (e) => {
    console.log('row data is', e);
    // setCustomerIdentifier(e.row.atlasID);
    // setClientRefId(e.row.clientRefId);
    // getCustomerLogin(e.row.atlasID);
    // getCustomerRequirementsView(e.row.atlasID);
    // // getNextOutstandingEntity(e.row.atlasId);
    refreshClientValues(e.row.cif_Number);
    openView();
  };

  const handleAdjudView = (e) => {
    console.log('row data is', e);
    getMemberInfo(e.row.membershipNo);
  };

  const getMemberInfo = async (e) => {
    await axios(`${baseUrl}/api/client/GetMembersByFundNo?medFundNo=${e.row.membershipNo}`).then(
      (result) => {
        console.log('returned members', result);
        console.log('returned members cif', result.data.result[0]);
        // setDependant(result.data.result[0]);
        setDependantList(result.data.result);
        setParentRefId(result.data.result[0].cif_number);
        getLimitUsage(result.data.result[0]);
        getLimitTotalUsage(result.data.result[0]);
        setClaimDetailsList([]);
        openAdjView();
      },
      (error) => {
        alert(`failed ${error}`);
      }
    );
  };

  const openView = () => {
    navigate('/clientportfolio/portfolio');
  };

  const openAdjView = () => {
    navigate('/claims/benefitsLookup');
  };

  const emptyRows = page > 0 ? Math.max(0, (1 + page) * rowsPerPage - tariffList.length) : 0;

  const filteredUsers = applySortFilter(tariffList, getComparator(order, orderBy), filterName);

  const isUserNotFound = filteredUsers.length === 0;

  return (
    <Container>
      <Typography variant="h6" gutterBottom>
        Search Results...
      </Typography>
      <Card>
        <ClientListToolbar
          numSelected={selected.length}
          filterName={filterName}
          onFilterName={handleFilterByName}
        />

        <Scrollbar>
          <TableContainer sx={{ minWidth: 800 }}>
            <Table size="small" aria-label="a dense table">
              <ClientListHead
                order={order}
                orderBy={orderBy}
                headLabel={TABLE_HEAD}
                rowCount={tariffList.length}
                numSelected={selected.length}
                onRequestSort={handleRequestSort}
                onSelectAllClick={handleSelectAllClick}
              />
              <TableBody>
                {filteredUsers
                  .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  .map((row) => {
                    /* eslint-disable camelcase */
                    const { tariffCode, tariffDescription } = row;
                    const isItemSelected = selected.indexOf(tariffCode) !== -1;

                    return (
                      <StyledTableRow
                        hover
                        key={tariffCode}
                        tabIndex={-1}
                        role="checkbox"
                        selected={isItemSelected}
                        aria-checked={isItemSelected}
                      >
                        <TableCell padding="checkbox" />
                        <TableCell align="left">{tariffCode}</TableCell>
                        <TableCell align="left">{tariffDescription}</TableCell>
                      </StyledTableRow>
                    );
                  })}
                {emptyRows > 0 && (
                  <TableRow style={{ height: 53 * emptyRows }}>
                    <TableCell colSpan={6} />
                  </TableRow>
                )}
              </TableBody>
              {isUserNotFound && (
                <TableBody>
                  <TableRow>
                    <TableCell align="center" colSpan={6} sx={{ py: 3 }}>
                      <SearchNotFound searchQuery={filterName} />
                    </TableCell>
                  </TableRow>
                </TableBody>
              )}
            </Table>
          </TableContainer>
        </Scrollbar>

        <TablePagination
          className={classes.tableFooter}
          rowsPerPageOptions={[8, 16, 24]}
          component="div"
          count={tariffList.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </Card>
    </Container>
  );
}
